import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/documente')({
  component: DocumenteLayout,
});

/**
 * Rutele statice ale zonei. Orice alt segment sub `/documente/` e un id de document, deci
 * editorul.
 *
 * ⚠️ Lista asta e ce ține `Main fixed` corect. Până la #110 zona avea două ecrane și
 * testul era „orice nu e `/documente` e editorul" — un test care devine fals tăcut la
 * fiecare ecran nou: `/documente/incarca` ar fi primit înălțime fixă și scroll blocat,
 * adică taie conținutul de jos fără să pară stricat. Un ecran nou se adaugă **aici**.
 */
const STATIC_PATHS = new Set(['/documente', '/documente/incarca', '/documente/in-asteptare']);

/**
 * Cadrul zonei de documente: registrul, ecranele de intrare a actelor și editorul unui
 * document emis.
 *
 * Aceeași formă ca la `/template-uri`, și din același motiv: **editorul cere `Main fixed`,
 * lista nu.** `fixed` dă înălțimea ecranului și oprește scroll-ul paginii, ca să scrolleze
 * doar coala, cu bara de formatare și structura pe loc. Pe listă ar fi tăiat rândurile de
 * jos.
 *
 * Antetul spune „Documente", nu „Documente emise", de la #110: zona a primit încărcarea
 * manuală (#108) și căsuța de email (#109), iar actele care intră pe acolo nu sunt emise
 * de noi. Ce ecran anume te uiți se citește din cardul lui, care-și poartă titlul.
 */
function DocumenteLayout() {
  const inEditor = useRouterState({
    select: (state) => !STATIC_PATHS.has(state.location.pathname.replace(/\/$/, '')),
  });

  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Documente</h1>
      </Header>

      <Main fixed={inEditor} className="flex flex-1 flex-col gap-4 sm:gap-6">
        <Outlet />
      </Main>
    </>
  );
}
